import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { formatDollars, TWO_DECIMAL_DIGITS } from '../../../utils/formatting';
import s from './EarningsDisplay.scss';
/**
 * The bulk of our earnings calculator's display. Contains a slot for a {@link Props.postfix|postfix}.
 */ const EarningsDisplay = ({ earnings, postfix, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['label']
    }, t('estimatedEarnings.label')), /*#__PURE__*/ React.createElement("span", {
        className: s['earnings']
    }, formatDollars(earnings, TWO_DECIMAL_DIGITS)), postfix);
};
EarningsDisplay.displayName = 'EarningsDisplay';
export default EarningsDisplay;
